<template>
  <v-dialog v-model="visible" max-width="500px" persistent>
    <v-card>
      <v-card-title class="d-flex justify-between border-b border-gray-200">
        <h3 class="form-title">{{ headingTitle }}</h3>
        <v-icon @click="closeDialog">mdi-close</v-icon>
      </v-card-title>

      <v-card-text>
        <div class="p-4">
          <div v-if="dialogLable === UpdateCaseDialogLabels.FE_NAME">
            <v-autocomplete
              item-text="fullName"
              item-value="_id"
              label="Assigned To"
              hide-details
              flat
              solo
              outlined
              dense
              :items="users"
              v-model="userId"
              class="mt-2 mb-2"
            ></v-autocomplete>

            <div class="mt-2">
              <v-checkbox
                v-model="updateVisits"
                label="Do you want to assign associated visit to selected assignee ?"
                :color="$vuetify.theme.currentTheme.primary"
                hide-details
              ></v-checkbox>
            </div>
          </div>

          <div v-if="dialogLable === UpdateCaseDialogLabels.STATUS">
            <v-autocomplete
              label="Outcome"
              :items="userDefinedStatusOptions"
              hide-details
              flat
              solo
              outlined
              dense
              v-model="statusOption"
              class="mt-2 mb-2"
            ></v-autocomplete>
          </div>

          <div v-if="dialogLable === UpdateCaseDialogLabels.ASSIGN_LOCATION">
            <v-autocomplete
              label="Branches"
              :items="branchWithUnassigned"
              item-text="branchName"
              item-value="_id"
              hide-details
              flat
              solo
              outlined
              dense
              v-model="selectedBranch"
              class="mt-2 mb-2"
            ></v-autocomplete>
            <v-autocomplete
              label="Teams"
              :items="filteredTeams"
              item-text="teamName"
              item-value="_id"
              hide-details
              flat
              solo
              outlined
              dense
              v-model="selectedTeam"
              v-if="teams && teams.length"
              :disabled="!selectedBranch"
              class="mt-2 mb-2"
            ></v-autocomplete>
          </div>
          <div v-if="dialogLable === UpdateCaseDialogLabels.ASSIGN_DEPARTMENT">
            <v-autocomplete
              label="Departments"
              :items="departmentWithUnassigned"
              item-text="departmentName"
              item-value="_id"
              hide-details
              flat
              solo
              outlined
              dense
              v-model="selectedDepartment"
              class="mt-2 mb-2"
            ></v-autocomplete>
            <v-autocomplete
              label="Designations"
              :items="filteredDesignations"
              item-text="designationName"
              item-value="_id"
              hide-details
              flat
              solo
              outlined
              dense
              :disabled="!selectedDepartment"
              v-model="selectedDesignation"
              class="mt-2 mb-2"
            ></v-autocomplete>
          </div>
          <div v-if="dialogLable === UpdateCaseDialogLabels.SALARY_TEMPLATE">
            <v-autocomplete
              label="Salary Template"
              :items="orgSalaryTemplates"
              item-text="template"
              item-value="_id"
              hide-details
              flat
              solo
              outlined
              dense
              v-model="templateId"
              class="mt-2 mb-2"
            ></v-autocomplete>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <div class="flex justify-end p-4">
        <v-btn class="normal-case" text @click="closeDialog">Cancel</v-btn>
        <!-- {{ isTeamEnabled }} -->
        <v-btn
          :color="$vuetify.theme.currentTheme.primary"
          class="white--text normal-case"
          v-if="isTeamEnabled"
          @click="updateItem"
          :loading="isLoading"
        >
          <v-icon left>mdi-content-save</v-icon>
          Save
        </v-btn>
        <v-btn
          v-else
          :color="$vuetify.theme.currentTheme.primary"
          class="white--text normal-case"
          @click="selectedStatusUpdate(userId)"
          :loading="isLoading"
        >
          <v-icon left>mdi-content-save</v-icon>
          Save
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { UpdateCaseDialogLabels } from '@/utils/workforce/constants'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    users: {
      type: Array
    },
    userDefinedStatusOptions: {
      type: Array
    },
    teams: { tyepe: Array },
    branches: { tyepe: Array },
    departments: { type: Array, default: () => [] },
    designations: { type: Array, default: () => [] },
    handleShowDialog: {
      type: Function,
      required: true
    },
    caseConfig: {
      type: Object
    },
    handleDeleteSelected: {
      type: Function
    },
    dialogLable: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      UpdateCaseDialogLabels,
      localItems: [...this.items],
      userId: null,
      statusOption: '',
      selectedTeam: '',
      selectedBranch: '',
      selectedDepartment: '',
      selectedDesignation: '',
      isLoading: false,
      updateVisits: false,
      orgSalaryTemplates: [],
      templateId: ''
    }
  },
  watch: {
    items: {
      handler(newItems) {
        this.localItems = [...newItems]
      },
      deep: true
    },
    dialogLable: {
      handler(newLabel) {
        // Reset selectedTeam and selectedBranch when dialog changes to AssignLocation
        if (newLabel === UpdateCaseDialogLabels.ASSIGN_LOCATION) {
          this.selectedTeam = ''
          this.selectedBranch = ''
        }
        // Reset selectedDepartment and selectedDesignation when dialog changes to AssignDepartment
        if (newLabel === UpdateCaseDialogLabels.ASSIGN_DEPARTMENT) {
          this.selectedDepartment = ''
          this.selectedDesignation = ''
        }
      }
    }
  },
  async mounted() {
    await this.getOrgSalary()
    // Initialize selectedTeam and selectedBranch if dialogLable is AssignLocation
    if (this.dialogLable === UpdateCaseDialogLabels.ASSIGN_LOCATION) {
      this.selectedTeam = ''
      this.selectedBranch = ''
    }
    // Initialize selectedDepartment and selectedDesignation if dialogLable is AssignDepartment
    if (this.dialogLable === UpdateCaseDialogLabels.ASSIGN_DEPARTMENT) {
      this.selectedDepartment = ''
      this.selectedDesignation = ''
    }
  },
  computed: {
    isTeamEnabled() {
      return (
        (this.dialogLable === UpdateCaseDialogLabels.TEAMS ||
          this.dialogLable === UpdateCaseDialogLabels.BRANCHES ||
          this.dialogLable === UpdateCaseDialogLabels.ASSIGN_LOCATION ||
          this.dialogLable === UpdateCaseDialogLabels.ASSIGN_DEPARTMENT) &&
        !this.items[0]?.caseNo
      )
    },
    headingTitle() {
      if (this.dialogLable === UpdateCaseDialogLabels.TEAMS) {
        return 'Assign Team'
      } else if (this.dialogLable === UpdateCaseDialogLabels.BRANCHES) {
        return 'Assign Branch'
      } else if (this.dialogLable === UpdateCaseDialogLabels.ASSIGN_LOCATION) {
        return 'Assign Location'
      } else if (this.dialogLable === UpdateCaseDialogLabels.ASSIGN_DEPARTMENT) {
        return 'Assign Department'
      } else if (this.dialogLable === UpdateCaseDialogLabels.SALARY_TEMPLATE) {
        return 'Assign Salary Template'
      } else if (this.dialogLable === UpdateCaseDialogLabels.STATUS) {
        return 'Update Outcome'
      }
      return 'Assignee'
    },
    // Filter teams based on selected branch
    filteredTeams() {
      if (!this.selectedBranch) {
        return []
      }

      const branchTeams = this.teams.filter((team) => team.branch === this.selectedBranch)

      return [
        ...branchTeams,
        {
          teamName: 'Unassigned',
          _id: null
        }
      ]
    },
    branchWithUnassigned() {
      return [
        ...this.branches,
        {
          branchName: 'Unassigned',
          _id: null
        }
      ]
    },
    departmentWithUnassigned() {
      return [
        ...this.departments,
        {
          departmentName: 'Unassigned',
          _id: null
        }
      ]
    },
    filteredDesignations() {
      if (!this.selectedDepartment) {
        return []
      }
      const designations = this.designations.filter(
        (el) => el.department?._id === this.selectedDepartment
      )

      return [
        ...designations,
        {
          designationName: 'Unassigned',
          _id: null
        }
      ]
    }
  },
  methods: {
    closeDialog() {
      this.userId = null
      this.statusOption = ''
      this.updateVisits = false
      this.selectedTeam = ''
      this.selectedBranch = ''
      this.selectedDepartment = ''
      this.selectedDesignation = ''
      this.handleShowDialog(false)
    },
    deleteSelectedArray() {
      this.handleDeleteSelected()
    },

    async caseUpdate(item, field, value, payload) {
      try {
        let id = item._id
        let response = await this.$axios.put(`/collection/case/${id}`, payload)
        if (field === 'assignedTo' && this.updateVisits) {
          let visitAssignedTo = value
          const newUser = this.users.find((user) => user._id === item.assignedTo)

          let newAssignedTo = newUser?.fullName
          let visitId = item.tasks[0]?._id
          await this.updateVisit(visitAssignedTo, visitId, newAssignedTo)
        }
        // const response = await axios.get(url);
        return response.data
      } catch (error) {
        this.$toast.error(error.response?.data?.message)
        console.error(error)
      }
    },
    async updateTemplateId(item) {
      try {
        const payload = {}
        payload.userInfo = {
          salaryTemplate: this.templateId
        }
        await this.$axios.patch(`/users/${item._id}?action=UPDATE_USER_INFO`, payload)
      } catch (error) {
        console.log(error)
      }
    },
    async getOrgSalary() {
      try {
        const response = await this.$axios.get('/org/salary-templates')
        this.orgSalaryTemplates = response.data.salaryTemplates?.filter((template) => {
          return template.isActive === true
        })
      } catch (error) {
        console.log(error)
      }
    },
    async selectedStatusUpdate() {
      this.isLoading = true
      let field
      let value
      if (this.dialogLable === UpdateCaseDialogLabels.FE_NAME) {
        field = 'assignedTo'
        value = this.userId
      } else if (this.dialogLable === UpdateCaseDialogLabels.STATUS) {
        field = 'userDefinedCaseStatus'
        value = this.statusOption
      }
      const payload = {
        [field]: value
      }
      // console.log({ payload })

      const promises = []

      if (this.dialogLable === UpdateCaseDialogLabels.SALARY_TEMPLATE) {
        this.items.forEach(async (item) => {
          promises.push(this.updateTemplateId(item))
        })

        try {
          await Promise.all(promises)
          this.userId = null
          this.$toast.success('Template Id updated successfully')
          this.isLoading = false
          this.closeDialog()
        } catch (error) {
          this.$toast.error(error.response?.data?.message)
          console.error(error)
        }

        return
      }

      // Handle AssignLocation case
      if (this.dialogLable === UpdateCaseDialogLabels.ASSIGN_LOCATION) {
        // For AssignLocation, we don't use the standard payload approach
        // Instead, we call updateItem which handles both team and branch
        await this.updateItem()
        return
      }

      // Handle AssignDepartment case
      if (this.dialogLable === UpdateCaseDialogLabels.ASSIGN_DEPARTMENT) {
        // For AssignDepartment, we don't use the standard payload approach
        // Instead, we call updateItem which handles both department and designation
        await this.updateItem()
        return
      }

      this.items.forEach(async (item) => {
        promises.push(this.caseUpdate(item, field, value, payload))
      })

      try {
        await Promise.all(promises)
        this.userId = null
        this.statusOption = ''
        this.$toast.success('Cases updated successfully')
        this.isLoading = false
        this.deleteSelectedArray()
        this.closeDialog()
      } catch (error) {
        this.$toast.error(error.response?.data?.message)
        console.error(error)
      }
    },

    async updateVisit(visitAssignedTo, visitId) {
      if (!visitAssignedTo) return
      const payload = {
        assignedTo: visitAssignedTo
      }
      await this.$axios.put(`/collection/case/task/${visitId}`, payload)
    },
    async updateItem() {
      this.isLoading = true
      const promises = []

      if (this.caseConfig) {
        // Case Update Logic
        const payload = {}
        if (this.dialogLable === UpdateCaseDialogLabels.ASSIGN_LOCATION) {
          if (this.selectedTeam !== '') {
            payload.team = this.selectedTeam
          }
          if (this.selectedBranch !== '') {
            payload.branch = this.selectedBranch
          }
        } else if (this.dialogLable === UpdateCaseDialogLabels.ASSIGN_DEPARTMENT) {
          if (this.selectedDepartment !== '') {
            payload.department = this.selectedDepartment
          }
          if (this.selectedDesignation !== '') {
            payload.designation = this.selectedDesignation
          }
        }

        this.items.forEach((item) => {
          promises.push(this.$axios.put(`/collection/case/${item._id}`, payload))
        })
      } else {
        // Employee Update Logic
        const payload = {}

        if (this.dialogLable === UpdateCaseDialogLabels.ASSIGN_LOCATION) {
          payload.userInfo = {}
          if (this.selectedTeam !== '') {
            payload.userInfo.team = this.selectedTeam
          }
          if (this.selectedBranch !== '') {
            payload.userInfo.branch = this.selectedBranch
          }
        } else if (this.dialogLable === UpdateCaseDialogLabels.ASSIGN_DEPARTMENT) {
          payload.userInfo = {}
          if (this.selectedDepartment !== '') {
            payload.userInfo.department = this.selectedDepartment
          }
          if (this.selectedDesignation !== '') {
            payload.userInfo.designation = this.selectedDesignation
          }
        }

        this.items.forEach((item) => {
          const promise = this.updateEmployeeInfo(item, payload)
          promises.push(promise)
        })
      }

      try {
        await Promise.all(promises)
        this.isLoading = false
        this.selectedTeam = ''
        this.selectedBranch = ''
        this.selectedDepartment = ''
        this.selectedDesignation = ''
        this.closeDialog()

        let successMessage = ''
        if (this.caseConfig) {
          successMessage = 'Cases updated successfully'
        } else {
          successMessage =
            this.dialogLable === UpdateCaseDialogLabels.TEAMS
              ? 'Employees updated with new team successfully'
              : this.dialogLable === UpdateCaseDialogLabels.ASSIGN_LOCATION
              ? 'Employees updated with new location successfully'
              : this.dialogLable === UpdateCaseDialogLabels.ASSIGN_DEPARTMENT
              ? 'Employees updated with new department successfully'
              : 'Employees updated with new branch successfully'
        }
        this.$toast.success(successMessage)
      } catch (error) {
        this.isLoading = false
        this.$toast.error(error.response?.data?.message || 'Failed to update')
        console.error(error)
      }
    },
    async updateEmployeeInfo(employee, payload) {
      try {
        const response = await this.$axios.patch(
          `/users/${employee._id}?action=UPDATE_USER_INFO`,
          payload
        )
        return response.data
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.v-dialog > .v-card > .v-card__title {
  padding: 16px !important;
}
.form-title {
  font-size: 1.25rem;
  padding: 0px;
  font-weight: 600;
  color: #21427d;
  margin: 0;
}
</style>
